export enum templateKeyMapping {
  FirstName = '{{ first-name }}',
  LenderName = '{{ accepted-bank-offer-name }}',
  SigningLink = '{{ bank-offer-link }}',
  MagicToken = '{{ magic-token }}',
}

export enum templateSource {
  LoanApplication = 'LoanApplication',
  LoanQuote = 'LoanQuote',
}

export type ITemplateKeys = {
  [key in templateKeyMapping]: {
    templateKey: templateKeyMapping;
    source: templateSource;
  };
};

export const templateKeys = {
  FirstName: {
    templateKey: templateKeyMapping.FirstName,
    source: templateSource.LoanApplication,
  },
  LenderName: {
    templateKey: templateKeyMapping.LenderName,
    source: templateSource.LoanQuote,
  },
  SigningLink: {
    templateKey: templateKeyMapping.SigningLink,
    source: templateSource.LoanQuote,
  },
  MagicToken: {
    templateKey: templateKeyMapping.MagicToken,
    source: templateSource.LoanApplication,
  },
};

export function includesLoanQuoteTemplateKey(inputString: string): boolean {
  for (const key in templateKeys) {
    const templateKeyInfo = templateKeys[key as keyof typeof templateKeys];

    if (
      templateKeyInfo.source === templateSource.LoanQuote &&
      inputString.includes(templateKeyInfo.templateKey)
    ) {
      return true;
    }
  }
  return false;
}
